export default __webpack_public_path__ + "static/media/Newday_LOA.5e12d209.pdf";